<template>
    <manage-password :customerClass="'mt-5'" :title="$translate('user_profile')" />
</template>

<script>
import ManagePassword from '../../components/ManagePassword.vue'
export default {
    components: { ManagePassword },
    name: 'CustomerProfile',
}
</script>